import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const HeaderCell = styled.th.withConfig({
  displayName: "FeatureTableHeaderCell__HeaderCell",
  componentId: "snh8ri-0"
})(["text-align:center;font-weight:normal;position:relative;width:", ";padding:16px 16px 0 16px;"], ({
  totalLevels
}) => totalLevels < 3 ? `calc(50%/${totalLevels})` : `calc(70%/${totalLevels})`);
const ContentWrapper = styled.span.withConfig({
  displayName: "FeatureTableHeaderCell__ContentWrapper",
  componentId: "snh8ri-1"
})(["display:flex;flex-direction:column;text-align:center;"]);
const FeatureTableHeaderCell = ({
  level,
  totalLevels,
  Content
}) => {
  return /*#__PURE__*/_jsx(HeaderCell, {
    totalLevels: totalLevels,
    children: /*#__PURE__*/_jsx(ContentWrapper, {
      children: Content
    })
  }, level);
};
export default FeatureTableHeaderCell;